import { render, staticRenderFns } from "./AppointmentUpdatedToCustomer.vue?vue&type=template&id=d6600b12"
import script from "./AppointmentUpdatedToCustomer.vue?vue&type=script&lang=js"
export * from "./AppointmentUpdatedToCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports